import FactCheckIcon from "@mui/icons-material/FactCheck";
import { PROFESSORS_EXAMS, SESSION_EXAMS, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListGrades from "./List";

export const resources = {
  isMenu: true,
  icon: <FactCheckIcon />,
  name: StudentServicePath + SESSION_EXAMS + "/" + PROFESSORS_EXAMS,
  title: "Оценки",
  list: <ListGrades />,
  permission: permissions.canPreviewProfessorsSessionExams,
  // TODO
  //   create: <CreateExams />,
  //   createPermission: permissions.canCreateExams,
  //   edit: <EditExams />,
  //   editPermission: permissions.canUpdateExams,
  //   show: <ShowExams />,
  //   showPermission: permissions.canPreviewExams,
  //   permission: permissions.canPreviewExams,
};
